module.exports = __webpack_public_path__ + "static/transfer_request1-273c9e191c6d94d84dce3c9c2d10722e.png";